import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getDangerZone } from "./index";

export const useGetDangerZone = () => {
  const customFetch = useClientContext();

  return useQuery({
    retry: false,
    queryKey: ["dangerzone"],
    queryFn: getDangerZone(customFetch),
  });
};
